export default "__VITE_ASSET__6KVqnost__"